export const defaultState = () => {
  let defaultStateValues = {}

  defaultStateValues = {
    experience: {
      data: "",
      time: 0
    },
    describes: {
      business: [],
      specifySelect: false,
      specifyValue: "",
      industry: "",
      data: {},
      time: 0
    },
    primaryGoal: {
      optionsValue: [],
      specifySelect: false,
      specifyValue: "",
      data: {},
      time: 0
    },
    isSubscribe: {
      data: false,
      time: 0
    },
    currentStep: 1,
    status: {
      success: false,
      error: false
    },
    totalTime: 0
  };
  if (("__gpOnboardingStep" in localStorage)) {
    try {
      const lastSurvey = JSON.parse(localStorage.getItem("__gpOnboardingStep"));
      if (lastSurvey.dataSubmit && lastSurvey.dataSubmit.data && lastSurvey.dataSubmit.data.user_level != "") {
        if (lastSurvey["experience"]) {
          defaultStateValues["experience"] = lastSurvey["experience"];
        }
        if (lastSurvey["describes"]) {
          defaultStateValues["describes"] = lastSurvey["describes"];
        }
        if (lastSurvey["primaryGoal"]) {
          defaultStateValues["primaryGoal"] = lastSurvey["primaryGoal"];
        }
        if (lastSurvey["isSubscribe"]) {
          defaultStateValues["isSubscribe"] = lastSurvey["isSubscribe"];
        }
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  }
  return defaultStateValues;
};

const state = defaultState();

export default state;
